module.exports = __webpack_public_path__ + "static/media/need-coping.a8c99ba3.jpg";